import { render } from "./FeedbackHeroNew.vue?vue&type=template&id=01e5b72c&scoped=true"
import script from "./FeedbackHeroNew.vue?vue&type=script&lang=js"
export * from "./FeedbackHeroNew.vue?vue&type=script&lang=js"

import "./FeedbackHeroNew.vue?vue&type=style&index=0&id=01e5b72c&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01e5b72c"]])

export default __exports__